import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ContactsPage, HomePage, LoginPage, PromoPage, TSStudioPage } from '../features';
import { AppOutletLayout } from './AppOutletLayout';

const router = createBrowserRouter([
    {
        path: "app",
        element: <AppOutletLayout />,
        children: [
            {
                index: true,
                element: <HomePage />
            },
            {
                path: "promo",
                element: <PromoPage />
            },
            {
                path: "tsstudio",
                element: <TSStudioPage />
            },
            {
                path: "contacts",
                element: <ContactsPage />
            }
        ]
    },
    {
        path: "login",
        element: <LoginPage/>,
    },
]);

export const AppRoutes = () => {
    return (
        <RouterProvider router={router} />
    );
};
